module.exports = __webpack_public_path__ + "img/mip.85511062.svg";